/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { Timestamp } from './timestamp';

const styles = cssMap({
	labelStyle: {
		minWidth: '120px',
	},
	valueStyle: {
		wordBreak: 'break-word',
	},
	rows: {
		paddingBlockStart: token('space.100'),
		paddingBlockEnd: token('space.100'),
		borderBlockEndColor: token('color.border', '#091E4224'),
		borderBlockEndStyle: 'solid',
		borderBlockEndWidth: token('border.width', '1px'),
	},
});

interface RelatedActivitiesRowProps {
	activity: ReactNode;
	avatarUrl?: string;
	timestamp: string;
}

export const RelatedActivitiesRow = ({
	timestamp,
	activity,
	avatarUrl,
}: RelatedActivitiesRowProps): JSX.Element | null => {
	if (activity === null || activity === undefined || activity === '' || !timestamp) {
		return null;
	}

	return (
		<Stack xcss={styles.rows}>
			<Flex alignItems="start" gap="space.100">
				<Box xcss={cx(styles.labelStyle)}>
					<Timestamp timestamp={timestamp} />
				</Box>
				<Inline space="space.075" alignBlock="center">
					<Avatar size="medium" src={avatarUrl} />
					<Box xcss={cx(styles.valueStyle)}>{activity}</Box>
				</Inline>
			</Flex>
		</Stack>
	);
};
